import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ComplaintPreview from '../components/ComplaintPreview/ComplaintPreview';
import {IS_INTERNAL_APP} from '../api/ApiSettings';
import {openUpdateWaybillDataModal} from '../actions/WaybillData';

class ComplaintOverview extends Component {

    onEditWaybillDataButtonClick = (id,waybillNumber, waybillCourier) => {
        this.props.openUpdateWaybillDataModal(id, waybillNumber, waybillCourier);
    }
    render(){
        return(
            <ComplaintPreview
                customer={this.props.customer}
                complaint={this.props.complaint}
                componentsToRender={this.props.componentsToRender}
                complaintType={this.props.complaint.complaintType}
                complaintPositions={this.props.complaintPositions}
                onEditWaybillDataButtonClick={this.onEditWaybillDataButtonClick}
                showEditButton={IS_INTERNAL_APP}/>
               
        );
    }
}

const mapStateToProps = (state) => {
    return {
        texts: state.texts.texts,
        complaint: state.complaint,
        customer: state.customer,
        complaintPositions: state.complaintPositions.positions,
        componentsToRender: state.complaintPositionsComponents.complaintPositionComponents,
        captcha: state.captcha
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        openUpdateWaybillDataModal: (complaintId,waybillNumber, waybillCourier) => dispatch(openUpdateWaybillDataModal(complaintId, waybillNumber, waybillCourier))
    };
};

ComplaintOverview.propTypes = {
    complaintPositions: PropTypes.array,
    customer: PropTypes.shape({
        name: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
        buildingNumber: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        flatNumber: PropTypes.string,
        postalCode: PropTypes.string,
        street: PropTypes.string
    }),
    complaint: PropTypes.object,
    openUpdateWaybillDataModal: PropTypes.func,
    componentsToRender: PropTypes.array
};

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintOverview);


// WEBPACK FOOTER //
// ./src/containers/ComplaintOverview.js